import React from 'react';
import { Bootstrap } from '../components';

/**
 * 导航栏组件
 */
export default class Header extends React.Component {
  render() {
    return (
      <header className="hidden-print">
        <Bootstrap.Navbar data={this.props.data} />
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Header.js